import axios from 'axios';
import moment from 'moment';

export const clientDiagnosisService = {
    // `today` is the browser's local day, so Active / Upcoming don't flip hours early on server UTC
    getClientDiagnosesService: (clientId) =>
        axios.get(`/client-diagnoses/client/${clientId}`, { auth: true, params: { today: moment().format('YYYY-MM-DD') } }),

    createClientDiagnosisService: (clientId, body) => axios.post(`/client-diagnoses/client/${clientId}`, body, { auth: true }),

    editClientDiagnosisService: (id, body) => axios.patch(`/client-diagnoses/${id}`, body, { auth: true }),

    setPrimaryClientDiagnosisService: (id) => axios.patch(`/client-diagnoses/${id}/primary`, {}, { auth: true }),

    deleteClientDiagnosisService: (id) => axios.delete(`/client-diagnoses/${id}`, { auth: true }),

    getDiagnosisMatchService: (params) => axios.get('/client-diagnoses/match', { auth: true, params }),
};
